export default __webpack_public_path__ + "static/media/013-koala.3450bcbf.svg";